export default function(text, stop, clamp) {
   let text_array = text.split(" ");
   let processed_text = {
      'default': '',
      'more': ''
   };
   //processed_text = text_array.slice(0, stop).join(' ') + (stop < text_array.length ? clamp || '...' : '');
   processed_text["default"] = text_array.slice(0, stop).join(' ');
   processed_text["more"] = (stop < text_array.length ? text_array.slice(stop, text_array.length-150+1) : '');

   return processed_text;
}